import React from "react";
import { AppleStoreDownload, GoogleStoreDownload } from "./buttons";

export default function WithSpeedoc(props) {
  return (
    <div id="withSpeedoc">
      <div className="header">
        <h3>Fast, Professional, Reliable</h3>
        <h2>With Speedoc, you can</h2>
      </div>
      <div className="content">
        <div className="left">
          <img
            className="bg"
            src="https://public.speedoc.com/design/images/speedoc.com/background/draw-bg.svg"
            alt="With Speedoc"
          />
          <div className="leftContent">
            <p>
              Consider Speedoc your mobile clinic for professional healthcare whenever you need it, wherever you are. No
              more travel time. No more waiting rooms. No more long lines.
            </p>
            <div className="stores">
              <button className="appStore ios" type="button" aria-label="get ios app">
                <AppleStoreDownload />
              </button>
              <button className="appStore android" type="button" aria-label="get android app">
                <GoogleStoreDownload />
              </button>
            </div>
          </div>
        </div>
        <div className="right">
          <div className="feature">
            <img
              alt="Save waiting travelling time."
              src="https://public.speedoc.com/design/images/speedoc.com/icons/time.svg"
            />
            <p>Save waiting & travelling time.</p>
          </div>
          <div className="feature">
            <img
              alt="Rest at home comfortably before the doctor arrives."
              src="https://public.speedoc.com/design/images/speedoc.com/icons/home.svg"
            />
            <p>Rest at home comfortably before the doctor arrives.</p>
          </div>
          <div className="feature">
            <img
              alt="Receive a fast response from a fully licensed medical team."
              src="https://public.speedoc.com/design/images/speedoc.com/icons/medical.svg"
            />
            <p>Receive a fast response from a fully licensed medical team.</p>
          </div>
          <div className="feature">
            <img
              alt="Be assured of a 24/7 available and reliable service"
              src="https://public.speedoc.com/design/images/speedoc.com/icons/secure.svg"
            />
            <p>Be assured of a 24/7 available and reliable service.</p>
          </div>
          <div className="feature">
            <img
              alt="Review upfront transparent pricing."
              src="https://public.speedoc.com/design/images/speedoc.com/icons/price.svg"
            />
            <p>Review upfront transparent pricing.</p>
          </div>
          <div className="feature">
            <img
              alt="Be assured of a 24/7 available and reliable service"
              src="https://public.speedoc.com/design/images/speedoc.com/icons/support.svg"
            />
            <p>Be assured of a 24/7 available and reliable service</p>
          </div>
        </div>
      </div>
    </div>
  );
}
